export default {
  // Hero
  heroTitle: 'Ankommen.\nDurchatmen.\nWohlfühlen.',
  heroSubtitle: 'Zwischen München, Starnberger See, Alpen und wohltuender Gelassenheit erwartet Sie ein Aufenthalt, der leicht beginnt und lange nachwirkt.',
  heroCtaPrimary: 'Zimmer anfragen',
  heroCtaSecondary: 'Unsere Zimmer entdecken',

  // Benefits
  benefitsTitle: 'Vom ersten Moment an Daheim.',
  benefitsLead: 'Im Hotel Alpenhof beginnt Erholung mit dem ersten Moment. Warme Atmosphäre, ruhige Lage und ein Haus mit Charakter schaffen genau das Gefühl, das eine Auszeit besonders macht: alpenländische Gemütlichkeit in idealer Lage nahe München und dem Starnberger See ums Eck.',
  benefit1Title: 'Ruhige Lage',
  benefit1Text: 'Erholsame Atmosphäre fernab vom Trubel, eingebettet in die idyllische Landschaft von Gauting im Würmtal.',
  benefit2Title: 'Nähe zu München',
  benefit2Text: 'Perfekte Anbindung an die Landeshauptstadt München mit der S-Bahn – ideal für Ausflüge und Geschäftsreisen.',
  benefit3Title: 'Starnberger See',
  benefit3Text: 'Nur wenige Minuten zum malerischen Starnberger See – perfekter Ausgangspunkt für Erkundungen am Wasser.',
  benefit4Title: 'Stilvolle Zimmer',
  benefit4Text: 'Liebevoll eingerichtete Zimmer mit alpenländischem Charme und modernem Komfort für erholsame Nächte.',
  benefit5Title: 'Persönliche Atmosphäre',
  benefit5Text: 'Herzliche Gastfreundschaft und individuelle Betreuung in familiärer Umgebung – Sie sind bei uns willkommen.',
  benefit6Title: 'Zahlreiche Ausflugsmöglichkeiten',
  benefit6Text: 'Vom Ammersee bis zur Zugspitze – und Oberbayern mittendrin.',

  // Tradition
  tradKicker: 'Über uns',
  tradTitle: 'Ein Haus der Ruhe und Gastlichkeit',
  tradLead: 'Das Hotel Alpenhof in Gauting ist heute ein stilvolles Hotel mit alpenländischem Charakter – ein Ort, an dem Gäste aus aller Welt Ruhe und Geborgenheit finden. Unsere langjährige Erfahrung in der Hotellerie verbinden wir mit persönlicher Betreuung und liebevollen Details, die Ihren Aufenthalt in Gauting zu etwas Besonderem machen.',
  tradCtaButton: 'Mehr über das Hotel',
  tradGalleryTitle: 'Einblicke ins Haus',
  tradGalleryLead: 'Entdecken Sie das Ambiente des Hotel Alpenhof Gauting',

  // Rooms preview
  roomsPreviewTitle: 'Unsere Zimmer',
  roomsPreviewLead: 'Stilvolle Zimmer mit alpenländischem Charme und modernem Komfort – Ihr Rückzugsort für erholsame Nächte in Gauting zwischen München und dem Starnberger See.',
  roomsPreviewKicker: 'Unsere Zimmer',
  roomsPreviewHeadline: 'Der perfekte Ort für eine gute Nacht.',
  roomsPreviewCta: 'Zu den Zimmern',

  // Excursions teaser
  exTeaserKicker: 'Ausflugsziele',
  exTeaserTitle: 'Heute See. Morgen Stadt. Übermorgen Alpen.',
  exTeaserLead: 'Entdecken Sie die schönsten Orte in der Umgebung. Rund um den Alpenhof warten Tage, die sich ganz unterschiedlich anfühlen dürfen. Mal zieht es einen ans Wasser, mal in die Stadt, mal Richtung Berge. Vieles liegt nah, vieles lässt sich spontan entscheiden.',
  exTeaserCta: 'Alle Ausflugsziele ansehen',
  exTeaserSlide1Label: 'Stadt & Kultur',
  exTeaserSlide1Title: 'München',
  exTeaserSlide1Desc: 'Glockenspiel am Marienplatz, Viktualienmarkt und Weltklasse-Museen: Die Landeshauptstadt ist mit der S-Bahn in rund 25 Minuten erreichbar.',
  exTeaserSlide1Duration: '25 Min. S-Bahn',
  exTeaserSlide2Label: 'Natur & Berge',
  exTeaserSlide2Title: 'Alpen',
  exTeaserSlide2Desc: 'Gipfel, Almwiesen und kristallklare Bergseen – die Alpen sind nur einen Blick entfernt.',
  exTeaserSlide2Duration: '60 Min. Fahrt',
  exTeaserSlide3Label: 'Natur & Erholung',
  exTeaserSlide3Title: 'Ammersee',
  exTeaserSlide3Desc: 'Segelboote, Schilfufer und Kloster Andechs auf dem Heiligen Berg – der Ammersee lädt zum Verweilen ein.',
  exTeaserSlide3Duration: '25 Min. Fahrt',
  exTeaserSlide4Label: 'Natur & Erholung',
  exTeaserSlide4Title: 'Starnberger See',
  exTeaserSlide4Desc: 'Klares Wasser, charmante Uferdörfer und Alpenpanorama – der Starnberger See liegt nur 10 Minuten entfernt.',
  exTeaserSlide4Duration: '10 Min. Fahrt',

  // Breakfast
  bfKicker: 'Frühstück & Aufenthalt',
  bfTitlePart1: 'Leben wie der',
  bfTitleKini: 'Kini',
  bfTitlePart2: 'persönlich.',
  bfLead1: 'Der Morgen beginnt im Alpenhof genussvoll und ohne Eile mit einem leckeren Frühstück.',
  bfLead2: 'Unser Frühstücksraum strahlt alpenländische Gemütlichkeit aus und lädt zum Verweilen ein. Im Sommer lockt der schöne Garten. Frisch gestärkt geht es dann zum Starnberger See, nach München oder in die Berge. Fragen Sie uns gerne nach Tipps und Empfehlungen.',
  bfFeat1Title: 'Hochwertige Produkte',
  bfFeat1Text: 'Bio-Erzeugnisse der Andechser Molkerei. Semmeln und Brot von der lokalen Bio-Bäckerei (als bester Bäcker Europas ausgezeichnet). Und weitere hochwertige Produkte.',
  bfFeat2Title: 'Persönlicher Service',
  bfFeat2Text: 'Betreuung liegt uns am Herzen. Sie möchten Ihr Frühstücksei wie Sie es lieben? Oder eine besondere Kaffee- oder Tee-Spezialität? Wir gehen auf Ihre Wünsche ein.',
  bfFeat3Title: 'Den Tag ausklingen lassen',
  bfFeat3Text: 'Bei einem Glas Wein oder Bier in unserer gemütlichen Kachelofenstube, im lauschigen Garten. Oder stöbern Sie in unserer hauseigenen Bibliothek nach Ideen für die nächsten Ausflüge.',
  bfKiniKicker: 'König Ludwig II.',
  bfKiniTitle: 'Der Märchenkönig',
  bfKiniDates: '1845 – 1886',
  bfKiniText1: 'Bayerns wohl bekanntester König – Erbauer von Neuschwanstein, Linderhof und Herrenchiemsee, schwärmerisch, zurückgezogen, bis heute Legende.',
  bfKiniText2: 'Mit unserer Region eng verbunden: Im Schloss Berg verbrachte er viel Zeit, im Starnberger See fand er sein rätselhaftes Ende. Die Votivkapelle in Berg und das Kreuz im Wasser erinnern bis heute daran.',
  bfKiniCta: 'Auf seinen Spuren in der Region',

  // Location
  locKicker: 'Unsere Lage',
  locTitleLine1: 'Ruhig gelegen.',
  locTitleLine2: 'Klug verbunden.',
  locLead: 'Gauting verbindet entspannte Ruhe mit vielen Möglichkeiten. Der Starnberger See, München und die schönsten Seiten der Region liegen angenehm nah.',
  locHL1Title: 'Gauting im Würmtal',
  locHL1Text: 'Ruhige Lage im malerischen Würmtal – südwestlich von München, sowohl mit dem Auto als auch mit der S-Bahn ideal zu erreichen.',
  locHL2Title: 'Nach München',
  locHL2Text: 'In nur 25 Minuten ins Münchner Stadtzentrum – mit dem Auto oder der S-Bahn, die nur wenige Gehminuten entfernt liegt.',
  locHL3Title: 'Zum Starnberger See',
  locHL3Text: 'Der Starnberger See liegt nur eine kurze Fahrt entfernt – ideal für Spaziergänge, Bootsfahrten und Ausflüge.',
  locHL4Title: 'Zu anderen Seen und den Alpen',
  locHL4Text: 'Nicht nur Seen wie der Ammersee, Wörthsee oder Staffelsee liegen nah, sondern auch die Berge. Die Zugspitze ist direkt mit S-Bahn und Zug erreichbar, mit dem Auto sowieso.',
  locHL5Title: 'Bestens erreichbar',
  locHL5Text: 'Kostenlose Parkplätze, Autobahnanbindung (A95/Garmisch, A96/Lindau) und die S-Bahn in Laufnähe.',
  locDist1: 'München Hbf',
  locDist2: 'Starnberger See',
  locDist3: 'Flughafen MUC',
  locDist4: 'Zugspitze',

  // Contact
  contactTitle: 'Kontakt & Anreise',
  contactLead: 'Wir freuen uns auf Ihre Anfrage – kontaktieren Sie uns für Ihre Buchung im Hotel Alpenhof Gauting.',
  contactBookTitle: 'Online buchen',
  contactBookSub: 'Verfügbarkeit prüfen & direkt reservieren',
  contactBookCta: 'Zur vollständigen Buchungsseite',
  contactBookPhone: 'Oder telefonisch:',
  contactNoRoom: 'Kein Zimmer verfügbar? Wir haben hier oft noch Optionen für Aufenthalte ab 3 Nächten.',
  contactNoRoomLink: 'Wenden Sie sich gerne direkt an uns.',
  contactInfoTitle: 'Kontaktinformationen',
  contactAddress: 'Adresse',
  contactAddressLines: 'Hotel Alpenhof Gauting\nUnterbrunner Straße 9\n82131 Gauting bei München',
  contactPhone: 'Telefon',
  contactEmail: 'E-Mail',
  contactArrivalTitle: 'Anreise',
  contactCarTitle: 'Mit dem Auto',
  contactCarText: 'A96 München – Lindau, Ausfahrt Unterpfaffenhofen/Germering und A95 München – Garmisch, Ausfahrt Starnberg, Richtung Gauting durch das romantische, kurvenreiche Würmtal.',
  contactTrainTitle: 'Mit der S-Bahn',
  contactTrainText: 'S6 bis Gauting (25 Min. vom Münchner Hauptbahnhof). Das Hotel ist 7 Gehminuten vom Bahnhof entfernt.',

  // CTA Banner
  ctaKicker: 'Aufenthalt im Alpenhof',
  ctaTitle: 'Ein Urlaub. Viele Möglichkeiten.',
  ctaText: 'Ob kurze Auszeit, Wochenendtrip oder längerer Aufenthalt – der Alpenhof bietet den passenden Rahmen für erholsame und abwechslungsreiche Tage.',
  ctaButton: 'Jetzt anfragen',
};
